<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <stock-list-filter :call-back="searchData" />
      </b-card-body>
      <b-table
        v-if="dataList.length > 0 "
        responsive="sm"
        :fields="fields"
        :items="dataList"
        striped
      >
        <template #cell(amount)="data">
          {{ data.item.amount }}
          <div v-if="data.item.units">
            <small class="text-primary">{{ data.item.units }}</small>
          </div>
        </template>
        <template #cell(title)="data">
          {{ data.item.title }}
          <div v-if="data.item.stock_groups">
            <small class="text-primary">{{ data.item.stock_groups }}</small>
          </div>
        </template>
        <template #cell(control)="data">
          <div class="text-right">
            <list-buttons
              primary-text="Görüntüle"
              :primary-action="'/app/stocks/view/' + data.item.id"
              :edit-action="'/app/stocks/edit/' + data.item.id"
              :delete-action="removeData"
              :data-id="data.item.id"
            />
          </div>
        </template>
      </b-table>
      <b-alert
        v-else
        show
        variant="info"
        class="mr-2 ml-2"
      >
        <div class="alert-body text-center">
          <div class="lead">
            Stok kaydı bulunamadı.
          </div>
          <div class="mt-1">
            <b-button
              variant="info"
              size="sm"
              :to="'/app/stocks/add/'"
            >
              Yeni Kayıt Oluştur
            </b-button>
          </div>
        </div>
      </b-alert>
      <b-card-footer>
        <b-pagination
          v-model="currentPage"
          :total-rows="dataCounts"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import {
  BTable, BCard, BCardBody, BButton, BAlert, BPagination, BCardFooter,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListDropdownButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import StockListFilter from '@/views/Admin/Stocks/Components/Filter.vue'

export default {
  name: 'Stocks',
  components: {
    StockListFilter,
    BCardFooter,
    BPagination,
    BAlert,
    ListButtons,
    BTable,
    BCard,
    BCardBody,
    BButton,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'scode',
          label: 'Stok Kodu',
        },
        {
          key: 'title',
          label: 'Malzeme',
        },
        {
          key: 'amount',
          label: 'Miktar',
        },
        {
          key: 'username',
          label: 'Ekleyen',
        },
        {
          key: 'control',
          label: '',
          thClass: 'text-nowrap width-50',
        },
      ],
      dataQuery: {
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['stocks/dataList']
    },
    dataCounts() {
      return this.$store.getters['stocks/dataCounts']
    },
    saveData() {
      return this.$store.getters['stocks/dataSaveStatus']
    },
    filterData() {
      return this.$store.getters['stocks/filterData']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getData()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.getData()
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.getData()
  },
  methods: {
    searchData() {
      const where = {}
      if (this.filterData.keywords) {
        this.dataQuery.or_like = {
          'stocks.scode': this.filterData.keywords,
          'stocks.title': this.filterData.keywords,
          'stock_groups.title': this.filterData.keywords,
        }
      } else {
        delete this.dataQuery.or_like
      }
      if (this.filterData.id_stock_groups) {
        where['stocks.id_stock_groups'] = this.filterData.id_stock_groups
      }
      if (this.filterData.id_users) {
        where['stocks.id_users'] = this.filterData.id_users
      }
      this.dataQuery.where = where
      this.getData()
    },
    getData() {
      this.$store.dispatch('stocks/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('stocks/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },

  },
}
</script>
